import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterializeModule } from 'angular2-materialize';
import { LaddaModule } from 'angular2-ladda';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { TextMaskModule } from 'angular2-text-mask';

import { TitleStepComponent } from './title-step/title-step.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { MerchantListCardComponent } from './merchant-list-card/merchant-list-card.component';
import { OfferRibbonComponent } from './offer-ribbon/offer-ribbon.component';

import { RupeeCurrencyPipe, TruncatePipe, JsonKeyPipe, KeysPipe, SafePipe, SafeHtmlPipe, DateSuffixPipe } from './pipes';

import { ValidateAadhaarDirective } from './validate-aadhaar';
import { ValidateAadhaarVidDirective } from './validate-aadhaar-vid';
import { RestrictInputDirective } from './restrict-input';
import { ValidateFormDirective } from './validate-form';

import { TestimonialsService } from './testimonials/testimonials.service';
import { DeviceDetectService } from './device-detect/device-detect.service';

import { OrderBannerComponent } from './order-banner/order-banner.component';
import { CustomeSelect2Component } from './custom-select2/custom-select2.component';
import { ModalComponent } from './modal/modal.component';
import { UpSellingComponent } from './up-selling/up-selling.component';
import { ClStatusComponent } from './cl-status/cl-status.component';
import { CountdownLoaderComponent } from './countdown-loader/countdown-loader.component';
import { SubHeaderComponent } from './sub-header/sub-header.component';
import { RazorPayPaymentComponent } from './razorpay-payment/razorpay-payment.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterializeModule,
    DeviceDetectorModule.forRoot(),
    TextMaskModule,
    LaddaModule.forRoot({
      style: 'contract',
      spinnerSize: 50,
      spinnerColor: '#1eba68 ',
      spinnerLines: 100,
    })
  ],
  declarations: [
    TitleStepComponent,
    TestimonialsComponent,
    MerchantListCardComponent,
    OfferRibbonComponent,
    OrderBannerComponent,
    RupeeCurrencyPipe,
    TruncatePipe,
    JsonKeyPipe,
    KeysPipe,
    SafePipe,
    SafeHtmlPipe,
    DateSuffixPipe,
    ValidateAadhaarDirective,
    ValidateAadhaarVidDirective,
    RestrictInputDirective,
    ValidateFormDirective,
    CustomeSelect2Component,
    ModalComponent,
    UpSellingComponent,
    ClStatusComponent,
    CountdownLoaderComponent,
    SubHeaderComponent,
    RazorPayPaymentComponent
  ],
  exports: [
    TitleStepComponent,
    TestimonialsComponent,
    MerchantListCardComponent,
    OfferRibbonComponent,
    OrderBannerComponent,
    RupeeCurrencyPipe,
    TruncatePipe,
    JsonKeyPipe,
    KeysPipe,
    SafePipe,
    SafeHtmlPipe,
    DateSuffixPipe,
    ValidateAadhaarDirective,
    ValidateAadhaarVidDirective,
    RestrictInputDirective,
    ValidateFormDirective,
    CustomeSelect2Component,
    UpSellingComponent,
    ModalComponent,
    ClStatusComponent,
    CountdownLoaderComponent,
    SubHeaderComponent,
    RazorPayPaymentComponent
  ],
  providers: [
    TestimonialsService,
    DeviceDetectService
  ]
})
export class ZestCommonModule { }
